import { render, staticRenderFns } from "./bidList.vue?vue&type=template&id=53b75912&scoped=true"
import script from "./bidList.vue?vue&type=script&lang=js"
export * from "./bidList.vue?vue&type=script&lang=js"
import style0 from "./bidList.vue?vue&type=style&index=0&id=53b75912&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b75912",
  null
  
)

export default component.exports